// extracted by mini-css-extract-plugin
export default {"codeEditorBox":"Wrapper_codeEditorBox__p9GTH","content":"Wrapper_content__Kwl6-","isCodeContent":"Wrapper_isCodeContent__M43B9","button":"Wrapper_button__hetMj"};